import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import { StreamLogo } from '../StreamLogo'

const Root = styled(Link)`
  display: flex;
  flex-direction: row;

  & svg {
    margin-right: 0.5rem;
  }

  & > span {
    font-variation-settings: 'wght' 600;
    font-size: ${({ size }) => size}rem;
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const Brand = ({ size }) => (
  <Root size={size} to="/">
    <StreamLogo size={size} />
    <span>{'Codelabs'}</span>
  </Root>
)

Brand.defaultProps = {
  size: 1,
}
